module.exports = __webpack_public_path__ + "img/lead-06e.2ea3b3f9.png";